import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import AdminUsers from './users/adminUsers';
import AdminOrders from './orders/adminOrders';
import { Route } from 'react-router';
import { NavLink } from 'react-router-dom';
import AdminCtas from './ctas/adminCtas';
import AdminDeliveryDays from './deliveryDays/adminDeliveryDays';
import AdminPushNotifications from './pushNotifications/adminPushNotifications';
import AdminCtaGroups from './ctaGroups/adminCtaGroups';
import AdminDeliveryDayView from './deliveryDays/adminDeliveryDayView';
import AdminEmails from './emails/adminEmails';
import AdminBills from './bills/adminBills';
import AdminBillView from './bills/adminBillView';
import DeliveryDayForm from './deliveryDays/deliveryDayForm';
import CtaForm from './ctas/ctaForm';
import CtaGroupForm from './ctaGroups/ctaGroupForm';
import PushNotificationForm from './pushNotifications/pushNotificationForm';
import AdminOrderView from './orders/adminOrderView';
import AdminServiceAreas from './serviceAreas/adminServiceAreas';
import ServiceAreaForm from './serviceAreas/serviceAreaForm';
import { connect } from 'react-redux';
import AdminDeliveryDayMarketplaceView from './deliveryDays/adminDeliveryDayMarketplaceView';
import AdminBillsGrouped from './bills/adminBillsGrouped';
import AdminPayoutReports from './payoutReports/adminPayoutReports';
import AdminCoupons from './coupons/adminCoupons';
import CouponForm from './coupons/couponForm';
import AdminChefs from './recipes/adminChefs';
import ChefForm from './recipes/chefForm';
import AdminRecipes from './recipes/adminRecipes';
import RecipeForm from './recipes/recipeForm';
import PackerDeliveryDayMarketplace from './packer/packerDeliveryDayMarketplace';
import AdminRoutePlanning from './routePlanning/adminRoutePlan';
import AdminDrivers from './drivers/adminDrivers';
import DriverForm from './drivers/driverForm';
import PackerDeliveryDays from './packer/packerDeliveryDays';
import PackerRoutes from './packer/packerRoutes';
import AdminStartDepots from './startDepots/adminStartDepots';
import StartDepotForm from './startDepots/startDepotForm';
import AdminItems from './items/adminItems';
import AdminItemForm from './items/adminItemForm';
import AdminRoutePlanV2 from './routePlanning/adminRoutePlanV2';
import AdminFeatures from './features/adminFeatures';
import FeatureForm from './features/featureForm';
import AdminCombinedOrderItems from './combinedOrderItems/adminCombinedOrderItems';
import AdminPaymentRefunds from './paymentRefunds/adminPaymentRefunds';
import AdminDeliveryDayMarketplaces from './deliveryDayMarketplaces/adminDeliveryDayMarketplaces';
import DeliveryDayMarketplaceForm from './deliveryDayMarketplaces/deliveryDayMarketplaceForm';
import AdminPaymentMethods from './paymentMethods/adminPaymentMethods';
import AdminPaymentMethodForm from './paymentMethods/adminPaymentMethodForm';
import AdminBusinessProfiles from './businessProfiles/adminBusinessProfiles';
import BusinessProfileForm from './businessProfiles/businessProfileForm';
import AdminItemOrderingForm from './items/adminItemOrderingForm';
import AdminSubscriptions from './subscriptions/adminSubscriptions';
import AdminSubscriptionForm from './subscriptions/adminSubscriptionForm';

const Admin = ({ match, currentUser }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const errorMessage = error ? <div className="alert alert-error m-t-5 m-b-5">{error}</div> : '';

  const loader = loading ? (
    <div className="text-center m-t-5 m-b-5">
      <div className="b-loader" />
    </div>
  ) : (
    ''
  );

  const isAdmin = currentUser && currentUser.authorities.indexOf('ROLE_ADMIN') !== -1;
  const isPacker =
    currentUser &&
    (currentUser.authorities.indexOf('ROLE_ADMIN') !== -1 || currentUser.authorities.indexOf('ROLE_PACKER') !== -1);
  const isAccountant =
    currentUser &&
    (currentUser.authorities.indexOf('ROLE_ADMIN') !== -1 || currentUser.authorities.indexOf('ROLE_ACCOUNTANT') !== -1);
  const isLogistic =
    currentUser &&
    (currentUser.authorities.indexOf('ROLE_ADMIN') !== -1 || currentUser.authorities.indexOf('ROLE_LOGISTICS') !== -1);

  return (
    <div className="main container">
      <h1>
        <FormattedMessage id={'admin.title'} />
      </h1>

      <div className="row m-t-6 m-b-6">
        {isAdmin ? (
          <>
            <div className="col-6 col-sm-3">
              <h4>
                <FormattedMessage id={'admin.menu.primary'} />
              </h4>
              <ul className="list-unstyled m-b-3">
                <li className="">
                  <NavLink className="link" to={`${match.path}/orderBatches`}>
                    <FormattedMessage id={'admin.links.orders'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/subscriptions`}>
                    <FormattedMessage id={'admin.links.subscriptions'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/users`}>
                    <FormattedMessage id={'admin.links.users'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/businessProfiles`}>
                    <FormattedMessage id={'admin.links.business.profiles'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/items`}>
                    <FormattedMessage id={'admin.links.items'} />
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="col-6 col-sm-3">
              <h4>
                <FormattedMessage id={'admin.menu.delivery'} />
              </h4>
              <ul className="list-unstyled m-b-3">
                <li className="">
                  <NavLink className="link" to={`${match.path}/deliveryDays`}>
                    <FormattedMessage id={'admin.links.delivery.days'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/deliveryDayMarketplaces`}>
                    <FormattedMessage id={'admin.links.delivery.day.marketplaces'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/serviceAreas`}>
                    <FormattedMessage id={'admin.links.service.areas'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/paymentRefunds`}>
                    <FormattedMessage id={'admin.links.payment.refunds'} />
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="col-6 col-sm-3">
              <h4>
                <FormattedMessage id={'admin.menu.marketing'} />
              </h4>
              <ul className="list-unstyled m-b-3">
                <li className="">
                  <NavLink className="link" to={`${match.path}/coupons`}>
                    <FormattedMessage id={'admin.links.coupons'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/ctas`}>
                    <FormattedMessage id={'admin.links.ctas'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/ctaGroups`}>
                    <FormattedMessage id={'admin.links.cta.groups'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/pushNotifications`}>
                    <FormattedMessage id={'admin.links.push.notifications'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/chefs`}>
                    <FormattedMessage id={'admin.links.chefs'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/recipes`}>
                    <FormattedMessage id={'admin.links.recipes'} />
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className="col-6 col-sm-3">
              <h4>
                <FormattedMessage id={'admin.menu.tech'} />
              </h4>
              <ul className="list-unstyled m-b-3">
                <li className="">
                  <NavLink className="link" to={`${match.path}/emails`}>
                    <FormattedMessage id={'admin.links.emails'} />
                  </NavLink>
                </li>
                <li className="">
                  <NavLink className="link" to={`${match.path}/features`}>
                    <FormattedMessage id={'admin.links.features'} />
                  </NavLink>
                </li>
              </ul>
            </div>
          </>
        ) : (
          ''
        )}

        {isLogistic ? (
          <div className="col-6 col-sm-3">
            <h4>
              <FormattedMessage id={'admin.menu.logistics'} />
            </h4>
            <ul className="list-unstyled m-b-3">
              <li className="">
                <NavLink className="link" to={`${match.path}/routePlanningV2`}>
                  <FormattedMessage id={'admin.links.route.optimisation'} /> v2
                </NavLink>
              </li>

              {isAdmin ? (
                <>
                  <li className="">
                    <NavLink className="link" to={`${match.path}/drivers`}>
                      <FormattedMessage id={'admin.links.drivers'} />
                    </NavLink>
                  </li>
                  <li className="">
                    <NavLink className="link" to={`${match.path}/startDepots`}>
                      <FormattedMessage id={'admin.links.start.depots'} />
                    </NavLink>
                  </li>
                  <li className="d-none">
                    <NavLink className="link" to={`/routePlanner`}>
                      <FormattedMessage id={'admin.links.route.planner'} />
                    </NavLink>
                  </li>
                </>
              ) : (
                ''
              )}
            </ul>
          </div>
        ) : (
          ''
        )}
        {isAccountant ? (
          <div className="col-6 col-sm-3">
            <h4>
              <FormattedMessage id={'admin.menu.accounting'} />
            </h4>
            <ul className="list-unstyled m-b-3">
              <li className="">
                <NavLink className="link" to={`${match.path}/bills`}>
                  <FormattedMessage id={'admin.links.bills'} />
                </NavLink>
              </li>
              <li className="">
                <NavLink className="link" to={`${match.path}/payoutReports`}>
                  <FormattedMessage id={'admin.links.payout.reports'} />
                </NavLink>
              </li>
              <li className="">
                <NavLink className="link" to={`${match.path}/combinedOrderItems`}>
                  <FormattedMessage id={'admin.links.combined.order.items'} />
                </NavLink>
              </li>
              {isAdmin ? (
                <>
                  <li className="">
                    <NavLink className="link" to={`${match.path}/paymentMethods`}>
                      <FormattedMessage id={'admin.links.payment.methods'} />
                    </NavLink>
                  </li>
                </>
              ) : (
                ''
              )}
            </ul>
          </div>
        ) : (
          ''
        )}
        {isPacker ? (
          <div className="col-6 col-sm-3">
            <h4>
              <FormattedMessage id={'admin.menu.packing'} />
            </h4>
            <ul className="list-unstyled m-b-3">
              <li className="">
                <NavLink className="link" to={`${match.path}/packing/deliveryDays`}>
                  <FormattedMessage id={'admin.links.packing'} />
                </NavLink>
              </li>
            </ul>
          </div>
        ) : (
          ''
        )}
      </div>
      <hr className="m-b-6" />

      {errorMessage}
      {loader}

      <Route
        exact
        path={`${match.path}/orderBatches`}
        render={(props) => <AdminOrders setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route path={`${match.path}/orderBatches/:orderBatchId`} render={(props) => <AdminOrderView {...props} />} />
      <Route
        path={`${match.path}/users`}
        render={(props) => <AdminUsers setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route
        exact
        path={`${match.path}/ctas`}
        render={(props) => <AdminCtas setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route path={`${match.path}/ctas/create`} render={(props) => <CtaForm action="create" {...props} />} />
      <Route path={`${match.path}/ctas/edit/:ctaId`} render={(props) => <CtaForm action="edit" {...props} />} />
      <Route
        path={`${match.path}/ctas/:apiVersion`}
        render={(props) => <AdminCtas setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route
        exact
        path={`${match.path}/ctaGroups`}
        render={(props) => <AdminCtaGroups setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route path={`${match.path}/ctaGroups/create`} render={(props) => <CtaGroupForm action="create" {...props} />} />
      <Route
        path={`${match.path}/ctaGroups/edit/:ctaGroupId`}
        render={(props) => <CtaGroupForm action="edit" {...props} />}
      />
      <Route
        exact
        path={`${match.path}/ctaGroups/v/:apiVersion`}
        render={(props) => <AdminCtaGroups setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route
        exact
        path={`${match.path}/deliveryDays`}
        render={(props) => <AdminDeliveryDays setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route
        path={`${match.path}/deliveryDays/create`}
        render={(props) => <DeliveryDayForm action="create" {...props} />}
      />
      <Route
        path={`${match.path}/deliveryDays/edit/:deliveryDayId`}
        render={(props) => <DeliveryDayForm action="edit" {...props} />}
      />
      <Route
        exact
        path={`${match.path}/deliveryDayMarketplaces`}
        render={(props) => <AdminDeliveryDayMarketplaces {...props} />}
      />
      <Route
        path={`${match.path}/deliveryDayMarketplaces/edit/:deliveryDayMarketplaceId`}
        render={(props) => <DeliveryDayMarketplaceForm action="edit" {...props} />}
      />
      <Route exact path={`${match.path}/items`} render={(props) => <AdminItems {...props} />} />
      <Route path={`${match.path}/items/order`} render={(props) => <AdminItemOrderingForm {...props} />} />
      <Route path={`${match.path}/items/create`} render={(props) => <AdminItemForm action="create" {...props} />} />
      <Route path={`${match.path}/items/edit/:itemId`} render={(props) => <AdminItemForm action="edit" {...props} />} />
      <Route
        exact
        path={`${match.path}/pushNotifications`}
        render={(props) => <AdminPushNotifications setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route
        path={`${match.path}/pushNotifications/create`}
        render={(props) => <PushNotificationForm action="create" {...props} />}
      />
      <Route
        path={`${match.path}/emails`}
        render={(props) => <AdminEmails setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route
        exact
        path={`${match.path}/bills`}
        render={(props) => <AdminBills setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route
        path={`${match.path}/bills/paid`}
        render={(props) => <AdminBills setLoading={setLoading} setError={setError} paid={true} {...props} />}
      />
      <Route
        path={`${match.path}/bills/grouped`}
        render={(props) => <AdminBillsGrouped setLoading={setLoading} setError={setError} paid={true} {...props} />}
      />
      <Route path={`${match.path}/bill/:billId`} render={(props) => <AdminBillView {...props} />} />
      <Route
        path={`${match.path}/deliveryDay/:deliveryDayId`}
        render={(props) => <AdminDeliveryDayView {...props} />}
      />
      <Route
        exact
        path={`${match.path}/deliveryDayMarketplaces/:deliveryDayMarketplaceId`}
        render={(props) => <AdminDeliveryDayMarketplaceView {...props} />}
      />
      <Route
        exact
        path={`${match.path}/payoutReports`}
        render={(props) => <AdminPayoutReports setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route
        exact
        path={`${match.path}/serviceAreas`}
        render={(props) => <AdminServiceAreas setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route
        path={`${match.path}/serviceAreas/create`}
        render={(props) => <ServiceAreaForm action="create" {...props} />}
      />
      <Route
        path={`${match.path}/serviceAreas/edit/:serviceAreaId`}
        render={(props) => <ServiceAreaForm action="edit" {...props} />}
      />
      <Route
        exact
        path={`${match.path}/coupons`}
        render={(props) => <AdminCoupons setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route path={`${match.path}/coupons/create`} render={(props) => <CouponForm action="create" {...props} />} />
      <Route
        path={`${match.path}/coupons/edit/:couponId`}
        render={(props) => <CouponForm action="edit" {...props} />}
      />
      <Route
        exact
        path={`${match.path}/chefs`}
        render={(props) => <AdminChefs setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route path={`${match.path}/chefs/create`} render={(props) => <ChefForm action="create" {...props} />} />
      <Route path={`${match.path}/chefs/edit/:chefId`} render={(props) => <ChefForm action="edit" {...props} />} />
      <Route
        exact
        path={`${match.path}/drivers`}
        render={(props) => <AdminDrivers setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route path={`${match.path}/drivers/create`} render={(props) => <DriverForm action="create" {...props} />} />
      <Route
        path={`${match.path}/drivers/edit/:driverId`}
        render={(props) => <DriverForm action="edit" {...props} />}
      />
      <Route
        exact
        path={`${match.path}/recipes`}
        render={(props) => <AdminRecipes setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route path={`${match.path}/recipes/create`} render={(props) => <RecipeForm action="create" {...props} />} />
      <Route
        path={`${match.path}/recipes/edit/:recipeId`}
        render={(props) => <RecipeForm action="edit" {...props} />}
      />
      <Route exact path={`${match.path}/paymentRefunds`} render={(props) => <AdminPaymentRefunds {...props} />} />
      <Route exact path={`${match.path}/subscriptions`} render={(props) => <AdminSubscriptions {...props} />} />
      <Route
        path={`${match.path}/subscriptions/edit/:subscriptionId`}
        render={(props) => <AdminSubscriptionForm {...props} />}
      />
      <Route exact path={`${match.path}/features`} render={(props) => <AdminFeatures {...props} />} />
      <Route path={`${match.path}/features/create`} render={(props) => <FeatureForm action="create" {...props} />} />
      <Route
        path={`${match.path}/features/edit/:featureId`}
        render={(props) => <FeatureForm action="edit" {...props} />}
      />
      <Route
        exact
        path={`${match.path}/combinedOrderItems`}
        render={(props) => <AdminCombinedOrderItems {...props} />}
      />
      <Route
        exact
        path={`${match.path}/startDepots`}
        render={(props) => <AdminStartDepots setLoading={setLoading} setError={setError} {...props} />}
      />
      <Route
        path={`${match.path}/startDepots/create`}
        render={(props) => <StartDepotForm action="create" {...props} />}
      />
      <Route
        path={`${match.path}/startDepots/edit/:startDepotId`}
        render={(props) => <StartDepotForm action="edit" {...props} />}
      />
      <Route exact path={`${match.path}/paymentMethods`} render={(props) => <AdminPaymentMethods {...props} />} />
      <Route
        path={`${match.path}/paymentMethods/create`}
        render={(props) => <AdminPaymentMethodForm action="create" {...props} />}
      />
      <Route
        path={`${match.path}/paymentMethods/edit/:paymentMethodId`}
        render={(props) => <AdminPaymentMethodForm action="edit" {...props} />}
      />
      <Route exact path={`${match.path}/businessProfiles`} render={(props) => <AdminBusinessProfiles {...props} />} />
      <Route
        path={`${match.path}/businessProfiles/edit/:businessProfileId`}
        render={(props) => <BusinessProfileForm action="edit" {...props} />}
      />
      <Route exact path={`${match.path}/packing/deliveryDays`} render={(props) => <PackerDeliveryDays {...props} />} />
      <Route
        path={`${match.path}/packing/deliveryDays/:deliveryDayId`}
        render={(props) => <PackerRoutes {...props} />}
      />
      <Route
        path={`${match.path}/packing/deliveryDays/:deliveryDayId/:customPackingType`}
        render={(props) => <PackerRoutes {...props} />}
      />
      <Route
        path={`${match.path}/packing/deliveryDayMarketplaces/:deliveryDayMarketplaceId`}
        render={(props) => <PackerDeliveryDayMarketplace {...props} />}
      />
      <Route path={`${match.path}/routePlanning`} render={(props) => <AdminRoutePlanning {...props} />} />
      <Route path={`${match.path}/routePlanningV2`} render={(props) => <AdminRoutePlanV2 {...props} />} />
    </div>
  );
};

Admin.propTypes = {};

Admin.defaultProps = {};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default connect(mapStateToProps)(Admin);
